﻿/*************** FILTERS DROPDOWNS START *********************/

document.addEventListener("DOMContentLoaded", function () {
    const filterButtons = document.querySelectorAll(".nav-filter-item-dropdown");
    const sortInputs = document.querySelectorAll('input[name="navFilterSortBy"]');

    filterButtons.forEach(button => {
        button.addEventListener("click", function (event) {
            event.preventDefault();
            event.stopPropagation();

            const currentItem = this.closest(".nav-filter-item");
            const currentDropdown = currentItem ? currentItem.querySelector(".nav-filter-dropdown-content") : null;

            if (!currentItem || !currentDropdown) {
                return;
            }

            const wasOpen = currentItem.classList.contains("active");

            document.querySelectorAll(".nav-filter-item").forEach(item => {
                item.classList.remove("active");

                const dropdown = item.querySelector(".nav-filter-dropdown-content");
                if (dropdown) {
                    dropdown.classList.remove("active");
                }
            });

            if (!wasOpen) {
                currentItem.classList.add("active");
                currentDropdown.classList.add("active");
            }
        });
    });

    document.addEventListener("click", function (event) {
        if (!event.target.closest(".nav-filter-item")) {
            document.querySelectorAll(".nav-filter-item").forEach(item => {
                item.classList.remove("active");

                const dropdown = item.querySelector(".nav-filter-dropdown-content");
                if (dropdown) {
                    dropdown.classList.remove("active");
                }
            });
        }
    });

    sortInputs.forEach(input => {
        input.addEventListener("change", function () {
            const selectedSort = this.value;

            if (!selectedSort) {
                return;
            }

            const url = new URL(window.location.href);
            url.searchParams.set("sort", selectedSort);
            window.location.href = url.toString();
        });
    });
});

/*************** FILTERS DROPDOWNS END *********************/